export const manuallyCreatedData = {
  "session_id": "session_id",
  "user_id": "ssd-12gfcpt",
  "order": {
    "order_id": "unique_order_011",
    "recommended_carton": [
      {
        "carton_id": "carton_id_2",
        "carton_type": "myd",
        "barcode": "000987654321",
        "box_id": "box_id_3"
      }
    ],
    "items": [
      {
        "id": "unique_sku_3_id",
        "sku": "Умная колонка Яндекс Станция Лайт, ультрафиолет",
        "barcode": "2134433212",
        "img": "https://static.mvideo.ru/media/Promotions/Promo_Page/2021/July/obzor-yandex-stantsii-lajt/obzor-yandex-stantsii-lajt-top1-m.png",
        "count": 1,
        "prompt": ["пузырчатая пленка", "непрозрачный пакет", "нужно сканировать IMEI"],
        "box_id": "box_id_3"
      },
      {
        "id": "unique_sku_4_id",
        "sku": "Умные часы Apple Watch Series 7 45 мм Aluminium Case, (PRODUCT)RED",
        "barcode": "0909092202",
        "img": "https://ipixel.ru/upload/iblock/a94/ua1sef2ps2eb3j790i2qxo655d2q1u8g.jpg",
        "count": 1,
        "prompt": ["нужно сканировать IMEI"],
        "box_id": "box_id_3"
      },
      {
        "id": "unique_sku_5_id",
        "sku": "Интимный гель-смазка Contex Green с антибактериальным эффектом, 30 мл",
        "barcode": "0123333333",
        "img": "https://evropharm.ru/Storage/gelj-smazka-contex-romantic-100ml-aromat.jpg",
        "count": 1,
        "prompt": ["непрозрачный пакет"],
        "box_id": "box_id_3"
      },
      {
        "id": "unique_sku_6_id",
        "sku": "Тарелка. Императорский фарфоровый завод. Форма 'Стандартная - 2', рисунок 'Скарлетт 2'. Костяной фарфор . 270 мм.",
        "barcode": "01221212124",
        "img": "https://fissman.ru/upload/resize_cache/webp/upload/iblock/1f7/azd2ffb6amk19it16ozmr3vldco8fdqu/FarforovayatarelkaTOLEDO21sm.webp",
        "count": 4,
        "prompt": ["пузырчатая пленка", "стретч-пленка"],
        "box_id": null
      }
    ]
  }
};